import qs from 'query-string';
import { BulkScopes } from 'UI/constants/defaults';
import { EntityType } from 'UI/constants/entityTypes';

export const createBulkEmailData = data => {
  const baseData = {
    audience: data.audience?.title || '',
    candidates: null,
    instructions: data.instructions || '',
    jobOrders: null,
    length: data.length?.title || '',
    template: data?.currentEmailBody || '',
    tone: data.tone?.title || '',
    type: data.bulkScope.title
  };

  if (data.bulkScope.id === BulkScopes.Marketing) {
    return {
      ...baseData,
      candidates:
        data.candidates.map(candidate => ({
          city: candidate.city || '',
          id: candidate.id,
          industry: candidate.industry || '',
          name: candidate.full_name,
          postalCode: candidate.zip || '',
          specialty: candidate.specialty || '',
          state: candidate.state || '',
          subspecialty: candidate.subspecialty || '',
          title: candidate.title
        })) || []
    };
  }

  if (data.bulkScope.id === BulkScopes.Recruiting) {
    return {
      ...baseData,
      jobOrders:
        data.jobOrders.map(job => ({
          city: job.city_name || '',
          id: job.id,
          industry: job.industry || '',
          postalCode: job.zip || '',
          specialty: job.specialty || '',
          state: job.state_name || '',
          subspecialty: job.subspecialty || '',
          title: job.title
        })) || []
    };
  }

  return baseData;
};

export const determineEntityType = ({ jobOrders, candidates }) => {
  if (jobOrders?.length > 0) return EntityType.Joborder;
  if (candidates?.length > 0) return EntityType.Candidate;
  return null;
};

export const shouldEnableAIDrawer = ({ isAIDrawerOpen, entityIds }) => {
  return isAIDrawerOpen && entityIds?.length > 0;
};

export const buildEntityEndpoint = ({ endpoint, queryParams, entityIds }) => {
  if (!endpoint || !entityIds?.length) return null;

  return qs.stringifyUrl(
    {
      url: endpoint,
      query: {
        ...queryParams,
        ids: entityIds
      }
    },
    { arrayFormat: 'comma' }
  );
};

export const formatEmailContent = variant => {
  return `<p><strong>Subject: </strong><span>${variant.subject}</span></p>${variant.body}`;
};

/**
 *
 * @param {Object} bulkData
 * @param {Object} [config]
 * @param {boolean} [config.isAIRecruitingFeatureActive ]
 * @returns {boolean}
 */
export const shouldEnableAction = (bulkData, config = {}) => {
  if (!bulkData?.bulkScope || !bulkData.to) return false;

  const { bulkScope, marketCandidates, jobOrderRecruitment } = bulkData;

  if (!bulkScope || !bulkScope.id) return false;

  if (bulkScope.id === BulkScopes.General) return false;

  if (bulkScope.id === BulkScopes.Marketing) {
    return marketCandidates?.length > 0;
  }

  if (bulkScope.id === BulkScopes.Recruiting) {
    return !!(jobOrderRecruitment?.length > 0 && config?.isAIRecruitingFeatureActive);
  }

  return true;
};

export const areEntityIdsDifferent = ({ currentEntities, newEntities }) => {
  const currentIds = currentEntities?.map(item => item.id) || [];
  const newIds = newEntities?.map(item => item.id) || [];

  if (currentIds.length !== newIds.length) return true;

  const newIdsSet = new Set(newIds);
  return !currentIds.every(id => newIdsSet.has(id));
};
